import { getWebsiteLiveStatus } from 'src/utils/storeSubscriptionConfigs';
import store from '@/redux/store';

export const isThemeCustomizableForStore = () => {
  const theme = store.getState().storeReducer.store?.theme;
  const { isNewStoreWebsiteLive, isNewStoreWebsiteInactive } = getWebsiteLiveStatus();
  return isNewStoreWebsiteLive || isNewStoreWebsiteInactive || theme?.custom_theme_flag;
};
